import { render, staticRenderFns } from "./regCheckIndex.vue?vue&type=template&id=781c1ec1&scoped=true&"
import script from "./regCheckIndex.vue?vue&type=script&lang=js&"
export * from "./regCheckIndex.vue?vue&type=script&lang=js&"
import style0 from "./regCheckIndex.vue?vue&type=style&index=0&id=781c1ec1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c1ec1",
  null
  
)

export default component.exports